function templateToGetSubElements(elementId) {
  return `const ${this.elementArrayName} =[...document.getElementById("${elementId}").querySelectorAll( "[dataitem='true']" )].filter(
    (element, index, array) =>
    !array.reduce((hasAncestorFlag, dataItem) => hasAncestorFlag || (element.compareDocumentPosition(dataItem) & Node.DOCUMENT_POSITION_CONTAINS) === 8, false)
  );`;
}

export const outputImageTemplate = ({
  dataName,
  effectingArrayOfHtmlElements,
  attr,
  loopVariable,
  dataItemIndex
}) => `
const ${loopVariable} = ${effectingArrayOfHtmlElements}[${dataItemIndex}].querySelector("[annotationname = '${attr}']");
if(${loopVariable} !== null && ${dataName}[${dataName}.length -i -1].${attr} !== undefined){
  ${loopVariable}.src = ${dataName}[${dataName}.length -i -1].${attr}.data;
  ${loopVariable}.name = ${dataName}[${dataName}.length -i -1].${attr}.name;
}
else if(${effectingArrayOfHtmlElements}[${dataItemIndex}].getAttribute('annotationname') === '${attr}' && ${dataName}[${dataName}.length -i -1].${attr} !== undefined){
  ${effectingArrayOfHtmlElements}[${dataItemIndex}].src = ${dataName}[${dataName}.length -i -1].${attr}.data;
  ${effectingArrayOfHtmlElements}[${dataItemIndex}].name = ${dataName}[${dataName}.length -i -1].${attr}.name;
}
`;

export const outputGeneralTemplate = ({
  dataName,
  effectingArrayOfHtmlElements,
  attr,
  htmlElement,
  loopVariable,
  advanceSelectLoopLabel,
  advanceSelectOuterLabel,
  dataItemIndex
}) => `
      const ${loopVariable} = ${effectingArrayOfHtmlElements}[${dataItemIndex}].querySelector("[annotationname = '${attr}']");
      if(${loopVariable} !== null){
        ${loopVariable}.${htmlElement} = ${dataName}[${dataName}.length -i -1].${attr};
        ${advanceSelectLoopLabel}
      }
      else if(${effectingArrayOfHtmlElements}[${dataItemIndex}].getAttribute('annotationname') === '${attr}'){
        ${effectingArrayOfHtmlElements}[${dataItemIndex}].${htmlElement} = ${dataName}[${dataName}.length -i -1].${attr};
        ${advanceSelectOuterLabel}
      }
    `;
export const outputDateTemplate = ({
  dataName,
  effectingArrayOfHtmlElements,
  attr,
  htmlElement,
  loopVariable,
  advanceSelectLoopLabel,
  advanceSelectOuterLabel,
  dataItemIndex
}) => `
      const ${loopVariable} = ${effectingArrayOfHtmlElements}[${dataItemIndex}].querySelector("[annotationname = '${attr}']");
      const dateIsoFormat = new Date(${dataName}[${dataName}.length -i -1].${attr});
      const outputString = (${dataName}[${dataName}.length -i -1].${attr}) ?   dateIsoFormat.getDate()+'-'+dateIsoFormat.getMonth()+'-'+dateIsoFormat.getFullYear() : '' ;
      if(${loopVariable} !== null){
        ${loopVariable}.${htmlElement} = outputString;
        ${advanceSelectLoopLabel}
      }
      else if(${effectingArrayOfHtmlElements}[${dataItemIndex}].getAttribute('annotationname') === '${attr}'){
        ${effectingArrayOfHtmlElements}[${dataItemIndex}].${htmlElement} = outputString;
        ${advanceSelectOuterLabel}
      }
    `;

export const outputArrayTemplate = ({
  dataName,
  effectingArrayOfHtmlElements,
  itemAttr,
  htmlElement,
  loopVariable,
  dataItemIndex
}) => `const ${loopVariable} = ${effectingArrayOfHtmlElements}[${dataItemIndex}].querySelector(
  "[annotationname = '${itemAttr}']"
);
const tableDataElement = ${loopVariable}.querySelectorAll(
  "[dataitem='true']"
);
const tableData = ${dataName}[${dataName}.length - i - 1].${itemAttr};
tableData.forEach((data, index) => {
  if(tableDataElement.length > index)
  tableDataElement[index].${htmlElement} = data;
});
tableDataElement.forEach((element, index) => {
  if (index >= tableData.length) element.style.display = "none";
});`;

const table = {
  componentName: 'Table',
  componentTag: 'tbody',
  componentSubTag: 'td',
  elementArrayName: 'subTableElements',
  templateToGetSubElements
};

const ul = {
  componentName: 'List group',
  componentTag: 'ul',
  componentSubTag: 'li',
  elementArrayName: 'subListElements',
  templateToGetSubElements
};

const generalGetAllComp = {
  componentName: 'General get all comp',
  componentTag: '',
  componentSubTag: '',
  elementArrayName: 'subDataElements',
  templateToGetSubElements
};

export const elementMap = new Map([
  ['tbody', table],
  ['ul', ul],
  ['general', generalGetAllComp]
]);

export const outputTemplateMap = new Map([
  ['image', outputImageTemplate],
  ['general', outputGeneralTemplate],
  ['array', outputArrayTemplate],
  ['date', outputDateTemplate]
]);

export function getElement(elementName) {
  return elementMap.get(elementName);
}

export default getElement;
